import { AuthGuard } from './../@shared/guards/auth.guard';
import { AuthAccessDeniedGuard } from './../@shared/guards/auth-access-denied.guard';
import { OrderDetailsComponent } from './../@module/order/order-details/order-details.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from '../@shared/components/layout/content/content.component';
import { content } from '../@shared/routes/routes';

const routes: Routes = [
	{
		path: '',
		loadChildren: () =>
			import('../@auth/auth.module').then((m) => m.AuthModule),
		canActivate: [AuthAccessDeniedGuard],
	},
	{
		path: 'admin',
		component: ContentComponent,
		children: content,
		canActivate: [AuthGuard],
	},
	{
		path: 'admin/orders/order-details/:id',
		component: OrderDetailsComponent,
		canActivate: [AuthGuard],
	},
	{
		path: '**',
		redirectTo: '',
	},
];

@NgModule({
	imports: [
		[
			RouterModule.forRoot(routes, {
				anchorScrolling: 'enabled',
				scrollPositionRestoration: 'enabled',
				relativeLinkResolution: 'legacy',
			}),
		],
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
